<template>
  <div>
    <div class="section-title">用户主动解约/买断申请记录</div>
    <div class="terminate-record-table">
      <el-table :data="tableData" size="small" border style="width: 100%">
        <el-table-column type="index" label="" width="55" />
        <el-table-column prop="cancelApplicationReasonTypeName" label="申请类型" min-width="120">
        </el-table-column>
        <el-table-column prop="cancelApplicationStatusName" label="申请状态" min-width="200" />
        <el-table-column prop="cancelRequestTime" label="申请时间" min-width="180" />
        <!-- add -->
        <el-table-column prop="refundTypeName" label="信用终止审核状态" min-width="180" />
        <el-table-column prop="cancelReason" label="用户解约原因" min-width="180" />
        <el-table-column prop="refundRemark" label="审核拒绝原因" min-width="180" />
        <el-table-column prop="chargePointPrice" label="设备金额" min-width="180" />
        <el-table-column prop="usedCreditPrice" label="已支付总会员费金额（元）" min-width="180" />
        <el-table-column prop="cancelAmount" label="免押扣款金额（元）" min-width="180" />
        <el-table-column prop="cancelFinishTime" label="免押扣款时间" min-width="180" />
        <el-table-column prop="updateInfoName" label="信用终止审核操作人" min-width="180" />
        <el-table-column prop="updateInfoTime" label="信用终止审核操作时间" min-width="180" />
      </el-table>
      <div class="pagination-container" v-if="pagination.total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.current" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TerminateRecord",
  props: { activityOrderNo: { type: String, default: "" }, terminateSummary: { type: Object, default: () => ({}) } },
  data() {
    return { tableData: [], pagination: { current: 1, pageSize: 10, total: 0 } };
  },
  watch: {
    activityOrderNo: {
      handler(newVal) {
        if (newVal) this.fetchData();
        else { this.tableData = []; this.pagination.total = 0; }
      },
      immediate: true,
    },
  },
  methods: {
    fetchData() {
      if (!this.activityOrderNo) return;
      const params = { activityOrderNo: this.activityOrderNo, pageNum: this.pagination.current, pageSize: this.pagination.pageSize };
      if (this.$store?.state?.corpNo) params.corpNo = this.$store.state.corpNo;
      this.$H.post(this, this.$A.zeropay.cancelOrderRecordPage, params).then((res) => {
        if (res?.data?.status === 200) {
          const rd = res.data.data || {};
          this.tableData = Array.isArray(rd) ? rd : (rd.content || rd.list || rd.records || []);
          this.pagination.total = Array.isArray(rd) ? rd.length : (rd.totalElements ?? rd.total ?? 0);
        } else {
          this.tableData = [];
          this.pagination.total = 0;
          this.$message.error(res?.data?.msg || res?.data?.message || "获取解约申请记录失败");
        }
      }).catch(() => {
        this.tableData = [];
        this.pagination.total = 0;
        this.$message.error("获取解约申请记录失败");
      });
    },
    handleSizeChange(val) { this.pagination.pageSize = val; this.pagination.current = 1; this.fetchData(); },
    handleCurrentChange(val) { this.pagination.current = val; this.fetchData(); },
  },
};
</script>

<style lang="less" scoped>
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.terminate-record-table {
  margin-top: 10px;
}

.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>
